module.exports = __webpack_public_path__ + "static/img_news-ea534a7a890e702077f6e71b0627285a.png";